export enum StoreActions {
    SET_STOREITEM = "setStoreItem",
    SET_SELECTED_STOREITEM = "setSelectedStoreItem",
    SET_STOREITEM_DETAILS = "setStoreItemDetails",
    TOGGLE_STOREITEM_PANEL = "toggleStoreItemPanel",
    RELOAD_STOREITEMS = "reloadStoreItem",
    SET_MAGAZINETYPE= "setMagazineType",
    CLEAR = "clearStoreItems",
}